const baseEndpoint =
  '/iphone/:ownerType/:ownerName/platforms/ios/apps/:bundleIdentifier/binaries';

export const paths = {
  index: baseEndpoint,
  show: `${baseEndpoint}/:revision`,
  installSession: `${baseEndpoint}/:revision/install_session`,
};
